const onlyDigits = (value: string) => value.replace(/\D/g, "")

const formatBrazilianPhone = (value: string) => {
  const digits = onlyDigits(value)

  const localDigits = digits.startsWith("55") && digits.length >= 12 ? digits.slice(2) : digits

  if (localDigits.length === 11) {
    return `(${localDigits.slice(0, 2)}) ${localDigits.slice(2, 7)}-${localDigits.slice(7)}`
  }

  if (localDigits.length === 10) {
    return `(${localDigits.slice(0, 2)}) ${localDigits.slice(2, 6)}-${localDigits.slice(6)}`
  }

  return value.trim()
}

export class PublicContactSettingsEntity {
  email: string | null

  whatsAppPhone: string | null

  whatsAppMessage: string | null

  cnpj: string | null

  constructor(value: Partial<PublicContactSettingsEntity> = {}) {
    this.email = value.email?.trim() || null

    this.cnpj = value.cnpj?.trim() || null

    this.whatsAppMessage = value.whatsAppMessage?.trim() || null

    const whatsappDigits = value.whatsAppPhone ? onlyDigits(value.whatsAppPhone) : ""

    this.whatsAppPhone =
      whatsappDigits.length === 10 || whatsappDigits.length === 11 ? `55${whatsappDigits}` : whatsappDigits || null
  }

  get emailUrl() {
    return this.email ? `mailto:${this.email}` : null
  }

  get whatsappUrl() {
    if (!this.whatsAppPhone) return null

    return this.whatsAppMessage
      ? `https://wa.me/${this.whatsAppPhone}?text=${encodeURIComponent(this.whatsAppMessage)}`
      : `https://wa.me/${this.whatsAppPhone}`
  }

  get whatsappLabel() {
    return this.whatsAppPhone ? formatBrazilianPhone(this.whatsAppPhone) : null
  }
}
